<template>
  <div v-if="isVisible" class="loader-overlay">
    <div class="loader-card">
      <div class="loader-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <!-- Your preferred loader icon, e.g., a cog or a box -->
          <path d="M20 7H4C2.9 7 2 7.9 2 9V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V9C22 7.9 21.1 7 20 7Z" stroke="#2c5aa0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="white"/>
          <path d="M16 21V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V21" stroke="#2c5aa0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="white"/>
          <path d="M12 7V9" stroke="#2c5aa0" stroke-width="2" stroke-linecap="round"/>
          <path d="M12 13V15" stroke="#2c5aa0" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="loader-text">{{ message }}</div>
      <div class="loader-progress">
        <div class="loader-progress-bar"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoaderAnimation",
  data() {
    return {
      isVisible: false,
      message: "Processing...",
      timeoutId: null,
    };
  },
  methods: {
    show(message = "Processing...") {
      this.message = message;
      this.isVisible = true;
    },
    hide() {
      this.isVisible = false;
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
    },
  },
};
</script>

<style scoped>
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.98);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.loader-card {
  background: white;
  border-radius: 12px;
  padding: 32px 48px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8ecf0;
  min-width: 280px;
}

.loader-icon {
  margin-bottom: 20px;
  display: inline-block;
  animation: iconPulse 1.2s ease-in-out infinite;
}

.loader-text {
  font-size: 14px;
  font-weight: 500;
  color: #2c5aa0;
  margin-bottom: 20px;
  letter-spacing: 0.3px;
}

.loader-progress {
  width: 180px;
  height: 2px;
  background: #e8ecf0;
  border-radius: 2px;
  overflow: hidden;
  margin: 0 auto;
}

.loader-progress-bar {
  width: 40%;
  height: 100%;
  background: #2c5aa0;
  border-radius: 2px;
  animation: progressMove 1s ease-in-out infinite;
}

@keyframes iconPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.05); opacity: 0.8; }
}

@keyframes progressMove {
  0% { transform: translateX(-100%); width: 40%; }
  50% { transform: translateX(0); width: 70%; }
  100% { transform: translateX(100%); width: 40%; }
}
</style>


// WEBPACK FOOTER //
// src/components/importables/LoaderAnimation.vue